import { createHead } from "@unhead/vue/client";
import type { App } from "vue";

export default {
  install: (app: App) => {
    const head = createHead();
    app.use(head);
  }
};
